// removed by extract-text-webpack-plugin
module.exports = {"container":"_2G06VC8d-eiCcwiUwzQEHV","text":"_2pqQdPNK368tEqonraQQXc"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/LoadingText/styles.css
// module id = 1470
// module chunks = 83